// Modelo Compañia para administrador.
export default class Anamesis {
    fecha={}
    motivoConsulta=""
    antecedentesPersonales=[
        {valor:false, descripcion:"", tipo:1 ,label:"1: VACUNAS"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. ENF. PERINATAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. ENF. INFANCIA"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. ENF. ADOLESCENTE"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. ENF. ALÉRGICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. ENF. CARDÍACA"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. ENF. RESPIRATORIA"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. ENF. DIGESTIVA"},
        {valor:false, descripcion:"", tipo:1 ,label:"9. ENF. NEUROLÓGICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"10. ENF. METABÓLICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"11. ENF. HEMO LINF"},
        {valor:false, descripcion:"", tipo:1 ,label:"12. ENF. URINARIA"},
        {valor:false, descripcion:"", tipo:1 ,label:"13. ENF. TRAUMATOLÓGICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"14. ENF. QUIRÚRGICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"15. ENF. MENTAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"16. ENF. T. SEXUAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"17. TENDENCIA SEXUAL"},
        {valor:false, descripcion:"", tipo:2 ,label:"18. RIESGO SOCIAL", valor2:"", requerido:true},
        {valor:false, descripcion:"", tipo:1 ,label:"19. RIESGO LABORAL"},
        {valor:false, descripcion:"", tipo:2 ,label:"20. RIESGO FAMILIAR", valor2:"", requerido:true},
        {valor:false, descripcion:"", tipo:1 ,label:"21. ACTIVIDAD FÍSICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"22. DIETA Y HÁBITOS"},
        {valor:false, descripcion:"", tipo:1 ,label:"23. RELIGIÓN Y CULTURAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"24. OTRO"},
        {valor:false, descripcion:"", tipo:3 ,label:"DIABETES",data:["SI","NO", "-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"25. LATERALIDAD" ,data:['IZQUIERDO','DERECHO','AMBIDIESTRO']},
        {valor:false, descripcion:"", tipo:3 ,label:"26. Discapacidad" ,data:["SI","NO"]},
        {valor:false, descripcion:"", tipo:3 ,label:"LOS EXÁMENES REALIZADOS FUERON" ,data:["NORMALES","ANORMALES"]},
        {valor:false, descripcion:"", tipo:2 ,label:"Descripción Exámenes"},
        {valor:false, descripcion:"", tipo:2 ,label:"MENARQUIA" },
        {valor:false, descripcion:"", tipo:2 ,label:"MENOPAUSIA"},
        {valor:false, descripcion:"", tipo:3 ,label:"CICLOS",data:["R","I"]},
        {valor:false, descripcion:"", tipo:3 ,label:"VIDA SEXUAL ACTIVA" ,data:["SI","NO", "-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"GESTA" ,data:[0,1,2,3,4,5,6,7,8,9,10,"-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"PARTOS" ,data:[0,1,2,3,4,5,6,7,8,9,10,"-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"ABORTOS" ,data:[0,1,2,3,4,5,6,7,8,9,10,"-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"CESÁREAS" ,data:[0,1,2,3,4,5,6,7,8,9,10,"-"]},
        {valor:false, descripcion:"", tipo:3 ,label:"HIJOS VIVOS" ,data:[0,1,2,3,4,5,6,7,8,9,10,"-"]},
        {valor:false, descripcion:"", tipo:2 ,label:"FUM"},
        {valor:false, descripcion:"", tipo:2 ,label:"FUP"},
        {valor:false, descripcion:"", tipo:2 ,label:"FUC"},
        {valor:false, descripcion:"", tipo:2 ,label:"BIOPSIA"},
        {valor:false, descripcion:"", tipo:2 ,label:"M.DE P.FAMILIAR"},
        {valor:false, descripcion:"", tipo:2 ,label:"T.HORMONAL"},
        {valor:false, descripcion:"", tipo:2 ,label:"COLPOS."},
        {valor:false, descripcion:"", tipo:2 ,label:"MAMOGRAFÍA"},
        {valor:false, descripcion:"", tipo:0 ,label:"ANTECEDENTES REPRODUCTIVOS MASCULINOS"},
        {valor:false, descripcion:"", tipo:2 ,label:"Eco próstata"},
        {valor:false, descripcion:"", tipo:2 ,label:"PSA"},
        {valor:false, descripcion:"", tipo:2 ,label:"Método de planificación"},

    ]
    antecentesFamiliares=[
        {valor:false, descripcion:"", tipo:1 ,label:"1. CARDIOPATÍA"},
        {valor:false, descripcion:"", tipo:1 ,label:"2. DIABETES"},
        {valor:false, descripcion:"", tipo:1 ,label:"3. ENF.C.VASCULAR"},
        {valor:false, descripcion:"", tipo:1 ,label:"4. HIPERTENSIÓN"},
        {valor:false, descripcion:"", tipo:1 ,label:"5. CÁNCER"},
        {valor:false, descripcion:"", tipo:1 ,label:"6. TUBERCULOSIS"},
        {valor:false, descripcion:"", tipo:1 ,label:"7. ENF.MENTAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"8. ENF.INFECCIOSA"},
        {valor:false, descripcion:"", tipo:1 ,label:"9. MALFORMACIÓN"},
        {valor:false, descripcion:"", tipo:1 ,label:"10. OTRO"}
    ]
    antecedentesFamiliaresMsp=[
        {valor:false, descripcion:"", tipo:1 ,label:"ENFERMEDAD METABÓLICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"ENFERMEDAD NEUROLÓGICA"},
        {valor:false, descripcion:"", tipo:1 ,label:"DISCAPACIDADES"}
    ]
    enfermedadProblemaActual=""
    revisionActualOrganosSistema=[
        {valor:false, descripcion:"", tipo:4 ,label:"1. ÓRGANOS DE LOS SENTIDOS"},
        {valor:false, descripcion:"", tipo:4 ,label:"2. RESPIRATORIO"},
        {valor:false, descripcion:"", tipo:4 ,label:"3. CARDIO VASCULAR"},
        {valor:false, descripcion:"", tipo:4 ,label:"4. DIGESTIVO"},
        {valor:false, descripcion:"", tipo:4 ,label:"5. GENITAL"},
        {valor:false, descripcion:"", tipo:4 ,label:"6. URINARIO"},
        {valor:false, descripcion:"", tipo:4 ,label:"7. MÚSCULO ESQUELÉTICO"},
        {valor:false, descripcion:"", tipo:4 ,label:"8. ENDÓCRINO"},
        {valor:false, descripcion:"", tipo:4 ,label:"9. HEMO-LINFÁTICO"},
        {valor:false, descripcion:"", tipo:4 ,label:"10. NERVIOSO"}    
    ]
    revisionActualOrganosSistemaMsp=[
        {valor:false, descripcion:"", tipo:2 ,label:"PIEL Y ANEXOS"},
    ]
    signosVitales=[
        {valor:today, descripcion:"", tipo:2 ,label:"FECHA DE MEDICIÓN", regla:"fecha" },
        {valor:"", descripcion:"", tipo:2 ,label:"PRESIÓN SISTÓLICA", regla:"" },
        {valor:"", descripcion:"", tipo:2 ,label:"PRESIÓN DIASTÓLICA", regla:"" },
        {valor:"", descripcion:"", tipo:2 ,label:"FREC. CARDÍACA" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"FREC. RESPIRATORIA", regla:"" },
        {valor:"", descripcion:"", tipo:2 ,label:"TEMPERATURA BUCAL C" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"TEMPERATURA AXILAR C" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"PESO /Kg" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"TALLA /cm", regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"PERÍMETRO ABDOMINAL", regla:"" },
        {valor:"", descripcion:"", tipo:2 ,label:"IMC" , regla:"calculado", type:"number"},
        {valor:"", descripcion:"", tipo:2 ,label:"TRIGLICÉRIDOS", regla:"" },
        {valor:"", descripcion:"", tipo:2 ,label:"HDL" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"GLUCOSA" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"COLESTEROL" , regla:""},
        {valor:"", descripcion:"", tipo:2 ,label:"SD METABÓLICO" , regla:"calculado", type:"text" }
    ]
    signosVitalesMsp=[
        {valor:"", descripcion:"", tipo:2 ,label:"SATURACIÓN DE OXÍGENO" , regla:""}
    ]
    examenFisico=[
        {valor:false, descripcion:"", tipo:4 ,label:"1-R PIEL Y FANERAS"},
        {valor:false, descripcion:"", tipo:4 ,label:"2-R CABEZA"},
        {valor:false, descripcion:"", tipo:4 ,label:"3-R OJOS"},
        {valor:false, descripcion:"", tipo:4 ,label:"4-R OÍDOS"},
        {valor:false, descripcion:"", tipo:4 ,label:"5-R NARIZ"},
        {valor:false, descripcion:"", tipo:4 ,label:"6-R BOCA"},
        {valor:false, descripcion:"", tipo:4 ,label:"7-R ORO-FARINGE"},
        {valor:false, descripcion:"", tipo:4 ,label:"8-R CUELLO"},
        {valor:false, descripcion:"", tipo:4 ,label:"9-R AXILAS-MAMAS"},
        {valor:false, descripcion:"", tipo:4 ,label:"10-R TÓRAX"},
        {valor:false, descripcion:"", tipo:4 ,label:"11-R ABDOMEN"},
        {valor:false, descripcion:"", tipo:4 ,label:"12-R COLUMNA VERTEBRAL"},
        {valor:false, descripcion:"", tipo:4 ,label:"13-R INGLE-PERINÉ"},
        {valor:false, descripcion:"", tipo:4 ,label:"14-R MIEMBROS SUPERIORES"},
        {valor:false, descripcion:"", tipo:4 ,label:"15-R MIEMBROS INFERIORES"},
        {valor:false, descripcion:"", tipo:4 ,label:"1-S ÓRGANOS DE LOS SENTIDOS"},
        {valor:false, descripcion:"", tipo:4 ,label:"2-S RESPIRATORIO"},
        {valor:false, descripcion:"", tipo:4 ,label:"3-S CARDIOVASCULAR"},
        {valor:false, descripcion:"", tipo:4 ,label:"4-S DIGESTIVO"},
        {valor:false, descripcion:"", tipo:4 ,label:"5-S GENITAL"},
        {valor:false, descripcion:"", tipo:4 ,label:"6-S URINARIO"},
        {valor:false, descripcion:"", tipo:4 ,label:"7-S MÚSCULO-ESQUÉLTICO"},
        {valor:false, descripcion:"", tipo:4 ,label:"8-S ENDÓCRINO"},
        {valor:false, descripcion:"", tipo:4 ,label:"9-S HEMO-LINFÁTICO"},
        {valor:false, descripcion:"", tipo:4 ,label:"10-S NEUROLÓGICO"}
    ]
    examenFisicoMsp={
        piel:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. CICATRICES"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. TATUAJES"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. PIEL Y FANERAS"}
        ],
        ojos:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. PÁRPADOS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. CONJUNTIVAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. PUPILAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"d. CÓRNEA"},
            {valor:false, descripcion:"", tipo:1 ,label:"e. MOTILIDAD"}
        ],
        oido:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. C. AUDITIVO EXTERNO"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. PABELLÓN"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. TÍMPANOS"}
        ],
        oroFaringe:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. LABIOS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. LENGUA"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. FARINGE"},
            {valor:false, descripcion:"", tipo:1 ,label:"d. AMÍGDALAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"e. DENTADURA"},
        ],
        nariz:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. TABIQUE"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. CORNETES"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. MUCOSAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"d. SENOS PARANASALES"}
        ],
        cuello:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. TIROIDES / MASAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. MOVILIDAD"}
        ],
        toraxA:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. MAMAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. CORAZÓN"}     
        ],
        toraxB:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. PULMONES"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. PARRILLA COSTAL"}
        ],
        abdomen:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. VÍSCERAS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. PARED ABDOMINAL"}
        ],
        columna:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. FLEXIBILIDAD"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. DESVIACIÓN"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. DOLOR"}
        ],
        pelvis:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. PELVIS"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. GENITALES"}
        ],
        extremidades:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. VASCULAR"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. MIEMBROS SUPERIORES"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. MIEMBROS INFERIORES"}
        ],
        neurologico:[
            {valor:false, descripcion:"", tipo:1 ,label:"a. FUERZA"},
            {valor:false, descripcion:"", tipo:1 ,label:"b. SENSIBILIDAD"},
            {valor:false, descripcion:"", tipo:1 ,label:"c. MARCHA"},
            {valor:false, descripcion:"", tipo:1 ,label:"d. REFLEJOS"}
        ]
    }
    diagnosticos=[]
    manifestacionesTempranas=[
        {valor:false, descripcion:"", tipo:4 ,label:"¿Usted considera haber tenido alteraciones en su salud a consecuencia del trabajo?"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT CARDIOVASCULAR"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT MUSCULO-ESQUELÉTICO"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT DERMATOLÓGICO"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT NUTRICIONAL Y METABÓLICO"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT RESPIRATORIO"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT AUDITIVO"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT SALUD MENTAL"},
        {valor:false, descripcion:"", tipo:1 ,label:"MT OFTALMOLÓGICO"}
    ]
    manifestacionesTempranasEspecificacion=""
    planesDeTratamientoLista=[]
    planesDeTratamiento=""
    certificadoOcupacional={}
    codigoMedico=""
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/Anamesis.js